import Tabbable from 'tabbable';

export default ({ app }, inject) => {
    inject('tabbable', Tabbable);
};
